import React, { useEffect, useState, useRef } from "react";
import ImageGallery from "react-image-gallery";
import useWindowDimensions from "../../Services/useWindowDimensions";
import "react-image-gallery/styles/css/image-gallery.css";

function SliderDetails({ data }) {
  const { width } = useWindowDimensions();
  const [showThumbnails, setShowThumbnails] = useState(true);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const galleryRef = useRef(null);
  const videoRefs = useRef({});
  const autoplayTimeoutRef = useRef(null);

  const mediaItems = [
    ...(data?.photos?.map((photo) => ({
      type: "image",
      original: photo,
      thumbnail: photo,
    })) || []),
    ...(data?.videos?.map((video, index) => ({
      type: "video",
      original: video,
      thumbnail: "https://img.icons8.com/ios-filled/50/000000/video.png",
      videoId: `video-${index}`, 
    })) || []),
  ];

  useEffect(() => {
    setShowThumbnails(width >= 600);
  }, [width]);

  useEffect(() => {
    return () => {
      if (autoplayTimeoutRef.current) {
        clearTimeout(autoplayTimeoutRef.current);
      }
    };
  }, []);

  const startAutoplay = () => {
    if (galleryRef.current) {
      galleryRef.current.play();
      galleryRef.current.slideToIndex((galleryRef.current.getCurrentIndex() + 1) % mediaItems.length);
    }
  };

  const handleVideoPlay = (videoId) => {
    setIsVideoPlaying(true);
    
    if (autoplayTimeoutRef.current) {
      clearTimeout(autoplayTimeoutRef.current);
    }
    
    Object.entries(videoRefs.current).forEach(([id, video]) => {
      if (id !== videoId && video) {
        video.pause();
      }
    });

    if (galleryRef.current) {
      galleryRef.current.pause();
    }
  };

  const handleVideoPause = () => {
    setIsVideoPlaying(false);
    startAutoplay();
  };

  const handleVideoEnd = () => {
    setIsVideoPlaying(false);
    
    if (autoplayTimeoutRef.current) {
      clearTimeout(autoplayTimeoutRef.current);
    }

    startAutoplay();
  };

  return (
    <ImageGallery
      ref={galleryRef}
      items={mediaItems}
      showThumbnails={showThumbnails}
      thumbnailPosition={showThumbnails ? "right" : "bottom"}
      showFullscreenButton={false}
      showPlayButton={false}
      showNav={false}
      autoPlay={!isVideoPlaying}
      slideInterval={5000}
      showBullets={false}
      infinite={true}
      renderItem={(item) =>
        item.type === "video" ? (
          <video
            ref={(el) => (videoRefs.current[item.videoId] = el)}
            controls
            style={{
              width: "100%",
              height: "548px",
              borderRadius: "8px",
            }}
            onPlay={() => handleVideoPlay(item.videoId)}
            onPause={handleVideoPause}
            onEnded={handleVideoEnd}
          >
            <source src={item.original} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <img
            src={item.original}
            alt="main slider"
            className="main-image-slider"
            style={{
              width: "100%",
              height: "548px",
              borderRadius: "8px",
            }}
          />
        )
      }
      renderThumbInner={(item) => (
        item.type === "video" ? (
          <img
            src="https://img.icons8.com/ios-filled/50/000000/video.png"
            alt="video thumbnail"
            style={{
              width: "90px",
              height: "75px",
              borderRadius: "4px",
              background: "#000",
              padding: "5px",
            }}
          />
        ) : (
          <img
            src={item.thumbnail}
            alt="thumbnail"
            style={{
              width: "90px",
              height: "75px",
              borderRadius: "4px",
            }}
          />
        )
      )}
      onBeforeSlide={(nextIndex) => {
        if (isVideoPlaying) {
          Object.values(videoRefs.current).forEach((video) => {
            if (video) video.pause();
          });
          setIsVideoPlaying(false);
        }
      }}
    />
  );
}

export default SliderDetails;